import styled from '@emotion/styled'
import { COLORS } from '@mafc/common'

export const BackToTopWrapper = styled.div`
  background: ${COLORS.PURPLE};
  width: 100%;
  font-weight: 500;
  padding: 16px;
  text-align: center;
  cursor: pointer;
`
